import React, {FC, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {TextField} from "../../../components/TextField";
import {Button} from "../../../UI/MUIButton";
import {Typography} from "../../../UI/Typography";
import {UploadFileField} from "../../../components/UploadFileField/UploadFileField";
import {migrateEntrata} from "../../../services/IntegrationApi";
import useAuth from "../../login/AuthContext";
import {useSnackbar} from "../../../hooks/useSnackbar";

interface EntrataMigrationModalProps {
    show: boolean;
    l1Id: number | undefined;
    oldPropertyId: number;
    closeModal: () => void;
}

export const EntrataMigrationModal: FC<EntrataMigrationModalProps> = ({show, l1Id, oldPropertyId,  closeModal}) => {
    const {getAuthToken} = useAuth();
    const {showErrorSnackbar, showSuccessSnackbar} = useSnackbar();
    const [propertyId, setPropertyId] = useState<number>();
    const [file, setFile] = useState<File | undefined>();

    const runMigration = async () => {
        if (propertyId && file && l1Id) {
            try {
                const response = await migrateEntrata(l1Id, oldPropertyId, propertyId, "ENTRATA", "ENTRATA", file, await getAuthToken());
                if (!response.ok) {
                    showErrorSnackbar("Migration failed");
                    return;
                }
                showSuccessSnackbar("Migration completed successfully");
                closeModal();
            } catch (error: any) {
                showErrorSnackbar("Migration failed");
            }
        }
    };

    return <Modal show={show} onHide={closeModal}>
        <Modal.Header closeButton>
            <Modal.Title>Migrate Entrata Property Id</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <Typography>
                With this tool, memberships in this Network will update their Entrata related identifiers to a new
                Entrata environment. By using this, memberships can continue matching unaffected when there is an
                Entrata side transition to a new environment.
            </Typography>
            <TextField value={propertyId} label={"New Entrata Property Id"}
                       onChange={(event: React.ChangeEvent<HTMLInputElement>) => setPropertyId(Number(event.target.value))}/>

            <UploadFileField label={"Choose a mapping file"} setFileToUpload={setFile}/>
            <Button type="submit" onClick={runMigration}>Submit</Button>
            <Button color="error" onClick={closeModal}>Cancel</Button>
        </Modal.Body>
    </Modal>;
};